import { OTA_PaymentCard } from "./ota_paymentcard.model";
import { OTA_Voucher } from "./ota_voucher.model";

export class OTA_RentalPaymentPref {
    public paymentType: number;
    public authorizedDays: number;

    public paymentCard = new OTA_PaymentCard();
    public voucher = new OTA_Voucher();
}
